module.exports = __webpack_public_path__ + "img/formal-0.74230f1d.jpg";